import {
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle
} from "@material-ui/core";
import React, { useState, useEffect } from "react";
import SessionRatingComponent from "./SessionRatingComponent";
import "./SessionRatinPopup.css";
import translate from "../../../i18n/translate";
import { getCookieValue } from "../../../cookieHelper";
const SessionRatingPopup = (props: any) => {

  const [dialog] = useState(true);
  const [isReadOnly] = useState(props.sessionRating.IsReadOnly);
  const [teacherName, setTeacherName] = useState(false);

  const [] = React.useState({
    Content: props.sessionRating.Content,
    Teacher: props.sessionRating.Teacher,
    Technology: props.sessionRating.Technology,
  });

  const readFile = async () => {
    const userLang: string = getCookieValue("ulang") || "";
    if(userLang.toUpperCase() === "JA-JP"){
      setTeacherName(true);
    }
  }

  useEffect(() => {
    readFile();
}, [getCookieValue("ulang")]);

  return (
    <React.Fragment aria-readonly={isReadOnly}>
      <Dialog className="session-rating-wrapper"  open={dialog} aria-label="Session rating"  TransitionProps={{ role: 'presentation' } as any}>
        <DialogTitle>
          {" "}
          <div className="ratings_header">
          {translate("SessionReport_rateSession")} <span id="tName"></span>
            <hr />
          </div>
        </DialogTitle>
        <DialogContent>
          {teacherName ? (
          <DialogContentText id="alert-dialog-description" className="Teacher" >
          {props.sessionRating.CoachName} {translate("SessionReport_coachName")}
          </DialogContentText>
          ) : (
            <DialogContentText id="alert-dialog-description" className="Teacher" >
            {translate("SessionReport_coachName")} {props.sessionRating.CoachName}?
            </DialogContentText>
          )}      
          <SessionRatingComponent sessionRating={props.sessionRating}
            setRatingPopup={props.setRatingPopup}
            StarRating={props.StarRating}></SessionRatingComponent>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
};

export default SessionRatingPopup;
